import { Nullable } from "models/Nullable";

export function mergeStrings(joinWith: string, strings: Nullable<string>[]): string {
    return strings.filter(str => ((str === null) ? '' : str.replaceAll(' ', '')) !== '').join(joinWith)
}